import { EventBusy } from '@mui/icons-material'
import { Alert, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { InternalLinkButton } from '@omnea-app/fe-routing/InternalLinkButton'
import { useGetOutOfOfficeDelegates } from '@omnea-app/fe-users-and-groups/useGetOutOfOfficeDelegates'

interface OutOfOfficeBannerProps {
  userId: string
}

export const OutOfOfficeBanner = ({ userId }: OutOfOfficeBannerProps) => {
  const { t } = useTranslation('dashboard')
  const { data: existingDelegates } = useGetOutOfOfficeDelegates({ delegatorId: userId })

  return (
    <Stack mb={4}>
      <Alert
        severity="info"
        icon={<EventBusy />}
        action={
          <InternalLinkButton href="/settings/preferences" size="small">
            {t('out-of-office-banner.action')}
          </InternalLinkButton>
        }
      >
        <Stack spacing={0.5}>
          <Typography variant="body-medium" component="span">
            {t('out-of-office-banner.title')}
          </Typography>
          <Typography variant="small-regular" component="span">
            {existingDelegates &&
              existingDelegates.outOfOfficeDelegations.length > 0 &&
              (existingDelegates.outOfOfficeDelegations.length === 1
                ? t('out-of-office-banner.body-single', {
                    delegateName: existingDelegates?.outOfOfficeDelegations[0]?.delegate?.firstName,
                  })
                : t('out-of-office-banner.body-multiple', {
                    delegateName: existingDelegates?.outOfOfficeDelegations[0]?.delegate?.firstName,
                    count: existingDelegates?.outOfOfficeDelegations.length - 1,
                  }))}
          </Typography>
        </Stack>
      </Alert>
    </Stack>
  )
}
